import type { ApiRoute, NoQueryParams } from "../api"
import type { PriceBreakdownView } from "../inventoryInformation/pricing/PriceBreakdownView"

export interface GetPriceBreakdownPathParams {
	inventoryId: string
}

export interface GetPriceBreakdownBody {
	accessories: string[]
	luxuryTaxIncluded: boolean
	numberOfTires: number
	vehiclePrice: number
}

export const getPriceBreakdownRoute: ApiRoute<
	GetPriceBreakdownPathParams,
	NoQueryParams,
	GetPriceBreakdownBody,
	PriceBreakdownView
> = {
	buildUrl: (params) => `/price-breakdown/${params.inventoryId}`,
	method: "post",
	path: "/price-breakdown/:inventoryId",
}
